export const defaultJsonConfig = {
  synonym_dict: null,
  num_json_level: 0,
  json_level_weights: "",
  substitute_by_parent: null,
  related_fields: null,
};
